import { Injectable } from '@angular/core';

@Injectable()
export class ToastService {
    public static readonly TYPE_MESSAGE = 'message';
    public static readonly TYPE_WARN = 'warning';
    public static readonly TYPE_ERROR = 'error';

    private message: string = '';
    private visibility = false;
    private timeout: number = null;
    private type: string = ToastService.TYPE_MESSAGE;

    public show(message: string, type: string, duration?: number): void {
        this.message = message;
        this.visibility = true;
        this.type = type;
        if (this.timeout !== null) {
            clearTimeout(this.timeout);
        }
        this.startTimeout(duration);
    }

    public reset() {
        this.message = '';
    }

    public startTimeout(duration?: number) {
        this.timeout = window.setTimeout(() => {
            this.visibility = false;
        }, typeof duration === 'undefined' ? 2000 : duration);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/services/toast.service.ts